import Menu from "@material-ui/icons/Menu";
import Notifications from "@material-ui/icons/Notifications";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { userDetail } from "../../config/userDetails";
import DropdownOptions from "../../constants/DropdownOptions";
import { handleNavbar } from "../../modules/user/redux/action";
import "../../style";
import { isCounterParty, isSuperAdmin } from "../Common/CheckAuthorization";
import FarmDropdown from "./FarmManagment/FarmDropdown";
import MainFarmDropdown from "./FarmManagment/MainFarmDropdown";
import HarvestYearDropDown from "./HarvestYear/HarvestYearDropDown";
import GroupByDropdown from "../Common/GroupByDropdown";
import PreviousDaysDropdown from "../Common/PreviousDaysDropdown";
import PreviousDaysForFarmsDropdown from "../Common/PrevioustDaysforFarmsAdded"

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      planId: userDetail().planId
    };
  }

  handleDrawerState = () => {
    this.props.handleNavbar(!this.props.DrawerReducer);
  };
  render() {
    const { planId } = this.state;
    return (
      <div className="navbar">
        <div className="initial">
          <button
            className="collapsedMenu isMobile"
            onClick={this.props.showDrawer}
          >
            <Menu />
          </button>
          <button
            className="collapsedMenu isweb"
            onClick={this.handleDrawerState}
          >
            <Menu />
          </button>
        </div>
        <div style={{
          display: "flex",
          alignItems: "center"
        }}>
          <div className="logoutSection dropdown">
         {!isCounterParty() && <React.Fragment>
{!(
              isSuperAdmin() && 
              this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id
            ) && (
                <div>
                  <p className="navDropDownHeading">Harvest Year</p>
                  <span className="userName">
                    <HarvestYearDropDown route={this.props.route} />
                  </span>
                </div>
              )}
         </React.Fragment>}
              {
                isCounterParty() && (<div className="GroupBydropdown">
                  <span className="userName">
                    <GroupByDropdown route={this.props.route} />
                  </span>
                </div>)
              }
              {
                isCounterParty() && (<div className="GroupBydropdown">
                  <span className="userName">
                    <PreviousDaysDropdown route={this.props.route} />
                  </span>
                </div>)
              }
              {/* {
                isCounterParty() && (<div className="GroupBydropdown">
                  <p className="navDropDownHeading"></p>
                  <span className="userName">
                    <PreviousDaysForFarmsDropdown route={this.props.route} />
                  </span>
                </div>)
              } */}
            {isSuperAdmin() && (
              <div>
                <p className="navDropDownHeading">Main Farm</p>
                <span className="userName mainFarm">
                  <MainFarmDropdown route={this.props.route} />
                </span>
              </div>
            )}
           {  !isCounterParty() && <div>
              <p className="navDropDownHeading">Farms</p>
              <span className="userName">
                <FarmDropdown route={this.props.route} />
              </span>
            </div>}
            {/* {!(isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id) && ( */}

            {/* { // )}} */}
            <div className="leftrod hide">
              <Link to="/profile">
                <span className="notifications ">
                  <Notifications />
                </span>
              </Link>
            </div>
          </div>
          <div>
            {this.props.route.match.path !== "/help" && !isCounterParty() &&(
              <Link
                to="/help"
                style={{
                  color: "blue",
                  paddingTop: "0.7em",
                  alignSelf: "center"
                }}
              >
                <span>User Guide</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    user: state.userData,
    DrawerReducer: state.DrawerReducer.isExpanDrawer,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

export default connect(mapStateToProps, { handleNavbar })(Navbar);



// WEBPACK FOOTER //
// ./src/components/private/Navbar.js